import { Injectable, Inject } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { GlobalVariable, WebChatVariables } from './global';
import { DatePipe } from '@angular/common';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { LocalStorageService } from 'angular-2-local-storage';
import { parseCookieValue } from '@angular/common/src/cookie';
import { MapOfHeader, TDUModel } from './models/shared-models';
import { TdusByZipCode } from './models/api-response-models';
import {DataDogRumService} from '../datadog/DataDogRumService';

@Injectable()
export class SharedService {
  // public behavior object
  public header_title: BehaviorSubject<MapOfHeader> = new BehaviorSubject<MapOfHeader>(null);
  public cashOnlyUser: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public SwitchHoldIndicator: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public reward_token: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public maps_of_header: Array<Object>;
  public error_messages: Object;
  // private baseApiUrl = GlobalVariable.BASE_API_URL;
  private baseApiUrlTest = GlobalVariable.BASE_API_URL;
  public temp_map: MapOfHeader;
  private req_headers = new Headers({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' });
  private local_json_config_url = 'assets/json/config.json';

  // django rest api urls
  private verify_token_url = this.baseApiUrlTest + 'api/auth/verifyToken';
  private verify_pin_url = this.baseApiUrlTest + 'api/auth/validate/pin';
  private is_email_verified_url = this.baseApiUrlTest + 'api/auth/email/verified';
  private sign_out_url = this.baseApiUrlTest + 'api/auth/logout';
  private validate_address_url = this.baseApiUrlTest + 'api/enrollment/enroll/find/address';
  private google_address_url = this.baseApiUrlTest + 'api/enrollment/street/ercot/search/';
  private get_tdu_url = this.baseApiUrlTest + 'api/enrollment/enroll/check/tdu/';
  private validate_esiid_url = this.baseApiUrlTest + 'api/enrollment/validate/esiid/';
  private enrollServiceAccountUrl = this.baseApiUrlTest + 'api/admin/service/add';
  private getProductsForEsiidUrl = this.baseApiUrlTest + 'api/admin/service/products/';
  private syncAccountUrl = this.baseApiUrlTest + 'api/admin/sync';
  private sendEmailUrl = this.baseApiUrlTest + 'api/admin/reset/email';
  private sendMobileUrl = this.baseApiUrlTest + 'api/admin/reset/mobile';
  private flag_search_url = this.baseApiUrlTest + 'api/admin/flagSearch';
  private esi_search_url = this.baseApiUrlTest + 'api/admin/esiid';
  private remove_ercot_switch_hold_url = this.baseApiUrlTest + 'api/admin/esiid/switch';
  private remove_esiid_hold_url = this.baseApiUrlTest + 'api/admin/removeEsiIdHold';
  private add_esiid_hold_url = this.baseApiUrlTest + 'api/admin/addEsiIdHold';
  private dpp_override_data_url = this.baseApiUrlTest + 'api/admin/dppOverrideData';
  private submit_dpp_override_url = this.baseApiUrlTest + 'api/admin/submitDppOverride';
  private config_const_url = this.baseApiUrlTest + 'api/enrollment/check/constraint/';
  private enroll = this.baseApiUrlTest + 'api/rest/v1/autocomplete/';
  private es_config_url = this.baseApiUrlTest + 'api/enrollment/get/esconfig/';
  private user_config_url = this.baseApiUrlTest + 'api/account/get/userconfig/';
  private reward_api = GlobalVariable.rewardsUrl + 'stream/datapost/';
  private holiday_list = this.baseApiUrlTest + 'api/enrollment/get/calendar/';

  constructor(private http: Http, private datePipe: DatePipe, @Inject(SESSION_STORAGE) private sessionStorageService: WebStorageService,
			  private dataDogRumService: DataDogRumService,
    private router: Router, private localStorageService: LocalStorageService) {

	  this.maps_of_header = [
		  {
			  'home': {
				  'is_header_title': true, 'header_title': 'Get Started',
				  'header_tagline': 'Check to see if you’re eligible for Pogo Energy service',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'is_header_remove': false, 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'home_msite': {
				  'is_header_title': true, 'header_title': 'Get Plan Information',
				  'header_tagline': 'View no-contract electricity plans in your area',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'is_header_remove': true, 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'default_page': {
				  'is_header_title': false, 'header_title': '', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'cancel_url': '', 'is_cancel_visible': false
			  },
			  'tdu_detail': {
				  'is_header_title': true, 'header_title': 'Almost There',
				  'header_tagline': 'Your area is served by more than one TDU',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {},
				  'component_name': 'home', 'is_loader': false, 'is_show_success_msg': false,
				  'success_message': '', 'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'tdu_detail_hide': {
				  'is_header_title': false, 'header_title': 'Almost There',
				  'header_tagline': 'your area is served by more than one TDU',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'plan_detail': {
				  'is_header_title': false, 'header_title': '', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'plan_detail',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '', 'header_class': '',
				  'cancel_url': '', 'is_cancel_visible': false
			  },
			  'personal': {
				  'is_header_title': false, 'header_title': '', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '', 'header_class': '',
				  'cancel_url': '', 'is_cancel_visible': false
			  },
			  'account': {
				  'is_header_title': false, 'header_title': '', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '', 'header_class': '',
				  'cancel_url': '', 'is_cancel_visible': false
			  },
			  'service_start': {
				  'is_header_title': false, 'header_title': '', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-height-fix', 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'summary': {
				  'is_header_title': false, 'header_title': '', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-height-fix', 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'otp_verify': {
				  'is_header_title': true, 'header_title': 'Well done.',
				  'header_tagline': 'Please verify your contact number.',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'email_otp_verify': {
				  'is_header_title': true, 'header_title': 'Well done.',
				  'header_tagline': 'Please verify your email.',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'otp_verify_agent': {
				  'is_header_title': true, 'header_title': 'Well done.',
				  'header_tagline': 'Please verify your contact number.',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'is_internal_user': true, 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'email_otp_verify_agent': {
				  'is_header_title': true, 'header_title': 'Well done.',
				  'header_tagline': 'Please verify your email.',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'is_internal_user': true, 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'addmoney': {
				  'is_header_title': true, 'header_title': 'Add Money', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },

			  'forget_password': {
				  'is_header_title': true, 'header_title': 'Forgot Password',
				  'header_tagline': 'Confirm your identity', 'notification_class': 'notification error',
				  'is_show_error': false, 'error_message': '', 'is_logged_in': false, 'user': {},
				  'component_name': 'home', 'is_loader': false, 'is_show_success_msg': false,
				  'success_message': '', 'is_cancel_visible': true, 'cancel_url': '/sign-in',
				  'header_class': 'header-fix with-title'
			  },

			  'create_new_password': {
				  'is_header_title': true, 'header_title': 'Change Password',
				  'header_tagline': 'Create new password', 'notification_class': 'notification error',
				  'is_show_error': false, 'error_message': '', 'is_logged_in': false, 'user': {},
				  'component_name': 'home', 'is_loader': false, 'is_show_success_msg': false,
				  'success_message': '', 'is_cancel_visible': true, 'cancel_url': '/sign-in',
				  'header_class': 'header-fix with-title'
			  },

			  'sign_in': {
				  'is_header_title': true, 'header_title': 'Sign In', 'header_tagline': 'Welcome back!',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'cancel_url': '', 'is_cancel_visible': false
			  },
			  'sign_in_agent': {
				  'is_header_title': true, 'header_title': 'Sign In', 'header_tagline': 'Welcome agent!',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'add_service_account': {
				  'is_header_title': true, 'header_title': 'Add Service Account', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'billing_sync': {
				  'is_header_title': true, 'header_title': 'Sync Account With Billing System', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'agent_dashboard': {
				  'is_header_title': true, 'header_title': 'Agent Dashboard', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'ban_search': {
				  'is_header_title': true, 'header_title': 'Billing Account SUP Download', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'account_search': {
				  'is_header_title': true, 'header_title': 'Account Search', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'flag_search': {
				  'is_header_title': true, 'header_title': 'Manage ESI ID Hold', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'dpp_override': {
				  'is_header_title': true, 'header_title': 'DPP Override', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'chargeback_process': {
				  'is_header_title': true, 'header_title': 'ChargeBack Process', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'dashboard_search': {
				  'is_header_title': true, 'header_title': 'Dashboard Search', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'manage_cards_search': {
				  'is_header_title': true, 'header_title': 'Manage Cards Search', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'cancel_url': '', 'is_cancel_visible': false,
				  'header_class': 'header-fix with-title', 'is_internal_user': true
			  },
			  'add_money': {
				  'is_header_title': true, 'header_title': 'Add Money', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },

			  'make_payment': {
				  'is_header_title_2': true, 'header_title': '', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },

			  'pay_credit_debit': {
				  'is_header_title': false, 'is_header_title_1': true, 'header_title': '30',
				  'header_tagline': 'to account 415 555 1234', 'notification_class': 'notification error',
				  'is_show_error': false, 'error_message': '', 'is_logged_in': false, 'user': {},
				  'component_name': 'home', 'is_loader': false, 'is_show_success_msg': false,
				  'success_message': '', 'is_cancel_visible': true, 'cancel_url': '/make-payment',
				  'header_class': 'header-fix with-title'
			  },

			  'payment_receive': {
				  'is_header_title': true, 'header_title': 'Recharge Received',
				  'header_tagline': '', 'notification_class': 'notification error',
				  'is_show_error': false, 'error_message': '', 'is_logged_in': false,
				  'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': true,
				  'cancel_url': '/make-payment', 'header_class': 'header-fix with-title'
			  },
			  'verify_payment': {
				  'is_header_title': true, 'header_title': 'Verify',
				  'header_tagline': 'Please select “Recharge” to apply this amount',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'is_cancel_visible': true, 'cancel_url': '/make-payment', 'header_class': 'header-fix with-title'
			  },
			  'submit_payment': {
				  'is_header_title': true,
				  'header_title': 'Verify Recharge',
				  'header_tagline': 'Please select “Recharge” to apply this amount',
				  'notification_class': 'notification error',
				  'is_show_error': false,
				  'error_message': '',
				  'is_logged_in': false,
				  'user': {},
				  'component_name': 'home',
				  'is_loader': false,
				  'is_show_success_msg': false,
				  'success_message': '',
				  'is_cancel_visible': false,
				  'cancel_url': '/make-payment',
				  'header_class': 'header-fix with-title'
			  },
			  'payment_successful': {
				  'is_header_title': true,
				  'header_title': 'Recharge Details',
				  'header_tagline': '',
				  'notification_class': 'notification error',
				  'is_show_error': false,
				  'error_message': '',
				  'is_logged_in': false,
				  'user': {},
				  'component_name': 'home',
				  'is_loader': false,
				  'is_show_success_msg': false,
				  'success_message': '',
				  'is_cancel_visible': false,
				  'cancel_url': '/make-payment',
				  'header_class': 'header-fix with-title'
			  },
			  'enrolling_now': {
				  'is_header_title': true,
				  'header_title': 'Processing',
				  'header_tagline': 'Hang tight, this may take a minute.',
				  'notification_class': 'notification error',
				  'is_show_error': false,
				  'error_message': '',
				  'is_logged_in': false,
				  'user': {},
				  'component_name': 'home',
				  'is_loader': false,
				  'is_show_success_msg': false,
				  'success_message': '',
				  'is_cancel_visible': false,
				  'cancel_url': '/make-payment',
				  'header_class': 'header-fix with-title'
			  },
			  'enrolling_email_verify': {
				  'is_header_title': true,
				  'header_title': 'Verify Email to Complete Enrollment',
				  'header_tagline': '',
				  'notification_class': 'notification error',
				  'is_show_error': false,
				  'error_message': '',
				  'is_logged_in': false,
				  'user': {},
				  'component_name': 'home',
				  'is_loader': false,
				  'is_show_success_msg': false,
				  'success_message': '',
				  'is_cancel_visible': false,
				  'cancel_url': '/make-payment',
				  'header_class': 'header-fix with-title'
			  },
			  'transaction_error': {
				  'is_header_title': true, 'header_title': "I am sorry we couldn't process your card.",
				  'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'is_cancel_visible': true, 'cancel_url': '', 'header_class': 'header-fix with-title'
			  },
			  'service-not-available': {
				  'is_header_title': true, 'header_title': 'Oh, no.',
				  'header_tagline': 'We can not provide service at this location',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },

			  'dashboard': {
				  'is_header_title': true, 'header_title': '', 'header_tagline': '',
				  'notification_class': '', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_show_success_msg': false, 'success_message': '', 'header_class': '',
				  'cancel_url': '', 'is_cancel_visible': false
			  },

			  'rewards': {
				  'is_header_title': true, 'header_title': 'Sign In', 'header_tagline': 'to check your rewards',
				  'notification_class': '', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_show_success_msg': false, 'success_message': '', 'header_class': '',
				  'cancel_url': '', 'is_cancel_visible': false
			  },

			  'fully_qualified_address': {
				  'is_header_title': true, 'header_title': 'Oh, no.',
				  'header_tagline': 'We are not sure about this service location',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },

			  'rate_plans': {
				  'is_header_title': true, 'header_title': 'Rate Plan', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'cancel_url': '', 'is_cancel_visible': false
			  },

			  'contact_us': {
				  'is_header_title': true, 'header_title': 'Contact Us',
				  'header_tagline': '', 'notification_class': 'notification error',
				  'is_show_error': false, 'error_message': '', 'is_logged_in': false,
				  'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'setHeaderTitleuccess_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },

			  'faq': {
				  'is_header_title': true, 'header_title': 'FAQs', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {},
				  'component_name': 'home', 'is_loader': false, 'is_show_success_msg': false,
				  'success_message': '', 'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },

			  'why_choose_pogo': {
				  'is_header_title': true, 'header_title': 'Why Choose Pogo?',
				  'header_tagline': '', 'notification_class': 'notification error',
				  'is_show_error': false, 'error_message': '', 'is_logged_in': false,
				  'user': {}, 'component_name': 'home', 'is_loader': false, 'cancel_url': '', 'is_cancel_visible': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title'
			  },

			  'rate_plan': {
				  'is_header_title': true, 'header_title': 'Rate Plan', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },

			  'change_phone_number': {
				  'is_header_title': true, 'header_title': 'Change Phone Number',
				  'header_tagline': '', 'notification_class': 'notification error',
				  'is_show_error': false, 'error_message': '', 'is_logged_in': false, 'user': {},
				  'component_name': 'home', 'is_loader': false, 'is_show_success_msg': false,
				  'success_message': '', 'is_cancel_visible': true, 'cancel_url': '/enrollment-wizard/account',
				  'header_class': 'header-fix with-title'
			  },

			  'account_change_phone_number': {
				  'is_header_title': true, 'header_title': 'Change Phone Number',
				  'header_tagline': '', 'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'is_cancel_visible': true, 'cancel_url': '/contact-info/AccountSetting',
				  'header_class': 'header-fix with-title'
			  },
			  'agent_change_phone_number': {
				  'is_header_title': true, 'header_title': 'Change Phone Number',
				  'header_tagline': '', 'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'is_cancel_visible': true, 'cancel_url': '/internal-user/account-search/account-setting/',
				  'header_class': 'header-fix with-title'
			  },

			  'express_pay': {
				  'is_header_title': true, 'header_title': 'Express Recharge',
				  'header_tagline': 'Charge up your Pogo Energy account',
				  'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'cancel_url': '', 'is_cancel_visible': false
			  },

			  'payment_locations': {
				  'is_header_title': false, 'header_title': '',
				  'header_tagline': '', 'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '', 'header_class': '',
				  'cancel_url': '', 'is_cancel_visible': false
			  },

			  'account_setting': {
				  'is_header_title': true, 'header_title': 'Account Information', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'cancel_url': '', 'is_cancel_visible': false
			  },

			  'contact_info': {
				  'is_header_title': true, 'header_title': 'Contact Information', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'cancel_url': '', 'is_cancel_visible': false
			  },

			  'account_search_setting': {
				  'is_header_title': true, 'header_title': 'Account Information', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'is_internal_user': true, 'cancel_url': '', 'is_cancel_visible': false
			  },
			  'change_service_address': {
				  'is_header_title': true, 'header_title': '', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': true,
				  'cancel_url': '/Profile/AccountSetting', 'header_class': 'header-fix with-title'
			  },

			  'page_not_found': {
				  'is_header_title': true, 'header_title': 'Oh, no.',
				  'header_tagline': 'Sorry, we couldn\'t find that content.',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'cancel_url': '', 'is_cancel_visible': false
			  },

			  'change_password': {
				  'is_header_title': true, 'header_title': 'Change Password',
				  'header_tagline': 'Create new password', 'notification_class': 'notification error',
				  'is_show_error': false, 'error_message': '', 'is_logged_in': false, 'user': {},
				  'component_name': 'home', 'is_loader': false, 'is_show_success_msg': false,
				  'success_message': '', 'is_cancel_visible': true, 'cancel_url': '/Profile/AccountSetting',
				  'header_class': 'header-fix with-title'
			  },

			  'manage_card': {
				  'is_header_title': true, 'header_title': 'Manage Payment Methods', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'manage_card', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': false,
				  'cancel_url': '', 'header_class': 'header-fix with-title'
			  },

			  'add_new_card': {
				  'is_header_title': true, 'header_title': 'Add New Card', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'manage_card', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': true,
				  'cancel_url': '/manage_payment_methods', 'header_class': 'header-fix with-title'
			  },

			  'autopay_setting': {
				  'is_header_title': true, 'header_title': 'Autopay Settings', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'manage_card', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': false,
				  'cancel_url': '', 'header_class': 'header-fix with-title'
			  },

			  'update_email': {
				  'is_header_title': true, 'header_title': 'Update Email', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'manage_card', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': true,
				  'cancel_url': '/contact-info/AccountSetting', 'header_class': 'header-fix with-title'
			  },

			  'agent_update_email': {
				  'is_header_title': true, 'header_title': 'Update Email', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'manage_card', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': true,
				  'cancel_url': '/contact-info/AccountSetting', 'header_class': 'header-fix with-title'
			  },
			  'email_verify': {
				  'is_header_title': true, 'header_title': 'Email Verification', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'manage_card', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': true,
				  'cancel_url': '/contact-info/AccountSetting', 'header_class': 'header-fix with-title'
			  },

			  'usage_payments': {
				  'is_header_title': true, 'header_title': 'Usage History', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'manage_card', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': false,
				  'cancel_url': '', 'header_class': 'header-fix with-title'
			  },

			  'dpp_usage_payments': {
				  'is_header_title': true, 'header_title': 'DPP History', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'manage_card', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': false,
				  'cancel_url': '', 'header_class': 'header-fix with-title'
			  },

			  'redirect': {
				  'is_header_title': true, 'header_title': 'Enrollment in Process…', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'is_cancel_visible': false,
				  'cancel_url': '/make-payment', 'header_class': 'header-fix with-title',
				  'is_footer_remove': true, 'is_header_remove': true
			  },
			  'congrats': {
				  'is_header_title': true, 'header_title': 'Congrats!', 'header_tagline': 'Your account is setup.',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'cancel_url': '', 'is_cancel_visible': false
			  },
			  'set_autopay': {
				  'is_header_title': true, 'header_title': 'Setup Auto Recharge', 'header_tagline': '',
				  'notification_class': 'notification error', 'is_show_error': false, 'error_message': '',
				  'is_logged_in': false, 'user': {}, 'component_name': 'home', 'is_loader': false,
				  'is_show_success_msg': false, 'success_message': '', 'header_class': 'header-fix with-title',
				  'cancel_url': '', 'is_cancel_visible': false
			  },
			  'thank_you': {
				  'is_header_title': true, 'header_title': 'Thank you.',
				  'header_tagline': '', 'notification_class': 'notification error', 'is_show_error': false,
				  'error_message': '', 'is_logged_in': false, 'user': {}, 'component_name': 'home',
				  'is_loader': false, 'is_show_success_msg': false, 'success_message': '',
				  'header_class': 'header-fix with-title', 'is_header_remove': false,
				  'cancel_url': '', 'is_cancel_visible': false
			  }
		  }

	  ];

    this.error_messages = {
      'address_not_found': 'Oops. We can’t seem to find the address or zip code you entered. Please <a href="https://pogoenergy.com/support/help/#chat" target="_blank">chat with us</a> and we’ll help figure it out.',
      'meter_not_qualified': 'Oops, the meter at this address is only partly smart (like Uncle Ned) and doesn\'t currently qualify for Pay as You Go service, which requires a fully smart meter.',
      'meter_not_active': 'Oops, something\'s wrong with this meter, and it can’t be enrolled with Pogo Energy. Please contact your <a href="https://pogoenergy.com/tducharges/" target="_blank">TDU</a>, #TDU#, to determine the issue.',
      'switch_hold': 'Oops. We can’t complete your enrollment at this location because it seems to have a switch hold on it. You may need to do a little work to get started. If you’re moving to this address, please follow these instructions to release the switch hold at <a href=\"https://pogoenergy.com/switch-hold-removal\" target=\"_blank\">PogoEnergy.com/SHR</a>. If you currently have service with another provider, please contact them to discuss your switch hold status.'
    };
  }

  gt_get_cookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }


  isEnglish() {
    const lang = this.gt_get_cookie('googtrans').split('/').pop();
    return lang === 'en' || lang === ''
  }

  listenLanguageCookieChange(callback, interval = 1000) {
    let lastCookie = document.cookie;
    setInterval(() => {
      const cookie = document.cookie;
      if (cookie !== lastCookie) {
        try {
          callback({ oldValue: lastCookie, newValue: cookie });
        } finally {
          lastCookie = cookie;
        }
      }
    }, interval);
  }
  getSaveTranslation() {
    if (this.isEnglish()) {
      return 'Save'
    } else {
      return 'Guardar'
    }
  }

  getSignOutTranslation() {
    if (this.isEnglish()) {
      return 'Sign Out'
    } else {
      return 'Cerrar sesión'
    }
  }

  setSwitchHoldIndicator(SwitchHoldIndicator: boolean) {
    this.SwitchHoldIndicator.next(SwitchHoldIndicator);
  }

  setCashOnlyUser(cashOnly: boolean) {
    this.cashOnlyUser.next(cashOnly);
  }

  setRewardToken(token: string) {
    this.reward_token.next(token);
  }

  getServiceAddressesByGoogle(address: Object) {
    return this.http
      .post(this.google_address_url, address)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }
  getServiceAddresses(address: string) {
    return this.http.get(this.enroll + address + '/')
      .map(response => response.json())
      .catch(this.handleError);
  }

  validateAddress(address: Object) {
    return this.http.post(this.validate_address_url, address)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getErrorMessages() {
    return { sign_in_msg: 'Username and password is require fields.' };
  }

  getErrorMessage(which_message: string) : string {
    return this.error_messages[which_message];
  }

  setHeaderTitle(header_title: string) {
    this.header_title.next(this.maps_of_header[0][header_title]);
    this.updateChat();
  }

  setHeaderTitleDynamicVal(header_title: string, title: string, tagline: string) {
    this.temp_map = this.maps_of_header[0][header_title];
    this.temp_map['header_title'] = title;
    this.temp_map['header_tagline'] = tagline;
    this.header_title.next(this.maps_of_header[0][header_title]);
    this.updateChat();
  }

  setHeaderTitleDynamicallyTrueFalse(header_title: string, is_header_title: boolean) {
    this.temp_map = this.maps_of_header[0][header_title];
    this.temp_map['is_header_title'] = is_header_title;
    this.header_title.next(this.maps_of_header[0][header_title]);
  }

  setHeaderTitleCancelUrl(header_title: string, cancel_url: string) {
    this.temp_map = this.maps_of_header[0][header_title];
    this.temp_map['cancel_url'] = cancel_url;
    this.header_title.next(this.maps_of_header[0][header_title]);
  }

  setHeaderUserLoggedIn(header_title: string, is_logged_in: boolean, user: Object) {
    this.temp_map = this.maps_of_header[0][header_title];
    this.temp_map['is_logged_in'] = is_logged_in;
    this.temp_map['user'] = user;
    this.header_title.next(this.maps_of_header[0][header_title]);

    WebChatVariables.isSignedIn = is_logged_in;
    if (!WebChatVariables.isSignedIn || user == undefined) {
      WebChatVariables.user.user_name = "Pogo Customer";
      WebChatVariables.isChatSignedIn = false;
    } else {
      WebChatVariables.user.user_name = user['firstName'] + " " + user['lastName'];
      WebChatVariables.user.user_id = user['accountNumber'];
      this.sessionStorageService.set('UserID', user['accountNumber']);
      this.sessionStorageService.remove('ConversationID');
      WebChatVariables.isChatSignedIn = true;
    }
    this.updateChat();
  }

  setHeaderErrorMessage(header_title: string, is_error_message: boolean, notification_class: string, error_message: string) {
    this.temp_map = this.maps_of_header[0][header_title];
    this.temp_map['is_show_error'] = is_error_message;
    this.temp_map['notification_class'] = notification_class;
    this.temp_map['error_message'] = error_message;
    this.header_title.next(this.temp_map);
  }

  setHeaderSuccessMessage(header_title: string, is_success_message: boolean, success_message: string) {
    this.temp_map = this.maps_of_header[0][header_title];
    this.temp_map['is_show_success_msg'] = is_success_message;
    this.temp_map['success_message'] = success_message;
    this.header_title.next(this.temp_map);
  }

  setLoader(header_title: string, is_loader: boolean) {
    this.temp_map = this.maps_of_header[0][header_title];
    this.temp_map['is_loader'] = is_loader;
    this.header_title.next(this.temp_map);
  }

    /** Get list of TDUs (Texas Electric Utility Providers) */
	getElectricUtilityProviders(): Promise<Array<TDUModel>> {
		return this.http.get(this.baseApiUrlTest + 'api/admin/tdus/true')
			.toPromise()
			.then(response => response.json())
			.catch(this.handleError);
	}

	/** Get TDU (Texas Electric Utility Providers) by Duns */
	GetElectricUtilityProvider(duns: string): Promise<TDUModel> {
		return this.http.get(this.baseApiUrlTest + 'api/admin/tdu/' + duns)
			.toPromise()
			.then(response => response.json())
			.catch(this.handleError);
	}

	/** Invoke HtmlElement Event */
	InvokeHtmlElementEvent(elementId: string, eventName: string) {
		let htmlElement = document.getElementById(elementId);
		if (!htmlElement) {
			return;
		}
		switch (eventName.trim()) {
			case 'focus':
				htmlElement.focus();
				break;
			case 'blur':
				htmlElement.blur();
				break;
			case 'click':
				htmlElement.click();
				break;
			default:
		}
	}

  async chatbot() {
    let convo_id = this.sessionStorageService.get('ConversationID');
    let token: string;
    let store: any;
    if (convo_id) {

      var result;
      await this.getWebChatConversation(convo_id)
      .then(res => {
        result = res;
      })
      .catch(err => {
        return null;
      })

      token = result.token;
      this.sessionStorageService.set("WebChatToken", token);

      store = (window as any).WebChat.createStore({}, ({ dispatch }) => next => action => {
        if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {

        }

        return next(action);
      });
    } else {
      var user_data = {
        user: {
          id: WebChatVariables.user.user_id,
          name: WebChatVariables.user.user_name
        }
      }
      var response;
      await this.getWebChatToken(user_data)
      .then(res => {
        response = res;
      })
      .catch(err => {
        return null;
      })

      token = response.token;
      convo_id = response.conversationId;
      this.sessionStorageService.set('ConversationID', convo_id);
      this.sessionStorageService.set('WebChatToken', token);

      store = (window as any).WebChat.createStore({}, ({ dispatch }) => next => action => {

        if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
          dispatch({
            type: 'WEB_CHAT/SEND_EVENT',
            payload: {
              name: 'webchat/join',
              from: { id: WebChatVariables.user.user_id, name: WebChatVariables.user.user_id },
            }
          });
        }

        return next(action);
      });
    }

    window.addEventListener('sendLeaveEvent', () => {

      store.dispatch({
        type: 'WEB_CHAT/SEND_EVENT',
        payload: {
          name: 'webchat/leave'
        }
      });
    });

    const directLine = (window as any).WebChat.createDirectLine({ token });
    (window as any).WebChat.renderWebChat({
      directLine: directLine,
      styleOptions: {
        hideUploadButton: true
      },
      locale: WebChatVariables.locale,
      userID: WebChatVariables.user.user_id,
      username: WebChatVariables.user.user_id,
      store
    },
      document.getElementById('botWindow')
    );




    // directLine
    //         .postActivity({
    //             from: { id: WebChatVariables.user.user_id, name: WebChatVariables.user.user_id },
    //             name: "requestWelcomeDialog",
    //             type: "event",
    //             value: "token"
    //         })
    //         .subscribe(
    //             id => console.log(`Posted activity, assigned ID ${id}`),
    //             error => console.log(`Error posting activity ${error}`)
    //         );

    (document.querySelector('#botWindow') as HTMLElement).focus();

    return store;
  }

  getWebChatToken(user_data: Object) {
    return this.http.post(this.baseApiUrlTest + "api/webchat/gettoken", user_data)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getWebChatConversation(convo_id: string) {
    return this.http.get(this.baseApiUrlTest + "api/webchat/getconversation/" + convo_id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  updateChat() {
    if (!WebChatVariables.isSignedIn && WebChatVariables.isChatSignedIn) {
      this.sessionStorageService.remove('ConversationID');
      this.sessionStorageService.remove('WebChatToken');
      WebChatVariables.user.user_name = "Pogo Customer";
    }

    WebChatVariables.user.user_id = this.sessionStorageService.get('UserID');
  }

  getRamdomExternalId() {
    let extId = '';
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 8; i++)
      extId += possible.charAt(Math.floor(Math.random() * possible.length));

    return extId;
  }

  scrollToTopSmoothly() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
	}

	/** Scroll Window until an specific element */
	ScrollToHere(event) {
		let element = event.target;
		if (element) {
			document.body.scrollTop = element.offsetTop;
		}
	}

  // token verify
  verifyToken(token: Object) {
    return this.http
      .post(this.verify_token_url, token)
      .toPromise()
      .then(res => {
		  const decoded = res.json();

		  if(decoded && decoded.results && decoded.results.length > 0) {
			  const person = decoded.results[0]['personal'];
			  const email = person[0]['email'];

			  if (person && person.length > 0) {
				  this.localStorageService.set('name', person[0].firstName + ' ' + person[0].lastName);
				  this.localStorageService.set('billingAccountNumber', person[0].accountNumber);

				  if (window.w1 && typeof window.w1 === 'function') {
					  if (!document.getElementById('chat-root')) {
						  console.error('Target element #chat-root not found');
					  } else {
						  const chatToken = this.localStorageService.get('token') || '';
						  if (chatToken && chatToken !== '') {
							  window.w1('setchatcontext', { token: chatToken, billingAccountNumber: person[0].accountNumber, name: person[0].firstName + ' ' + person[0].lastName });
						  }
					  }
				  }
			  }

			  this.dataDogRumService.storeUser({
				  email,
				  id: person[0]['accountId'],
				  billingAccountNumber: person[0]['billingAccountNumber'],
				  status: person[0]['accountStatusName'],
				  username: person[0]['username']
			  })
		  }

		  return decoded;
	  })
      .catch(this.handleError);
  }
  verifyAccountPin(pin: Object) {
    return this.http
      .get(this.verify_pin_url + '?identifier=' + pin['identifier'] + '&isEmail=' + pin['isEmail'] + '&pin=' + pin['pin'])
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }
  isEmailVerified(token: Object) {
    return this.http
      .post(this.is_email_verified_url, token)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  get_elastic_search_url() {
    return this.http
      .get(this.es_config_url)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  signOut(token: Object) {
    return this.http
      .post(this.sign_out_url, token)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  getTDUsByZipCode(zipCode: string): Promise<TdusByZipCode> {
	  return this.http.post(this.get_tdu_url, { 'zipcode': zipCode })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  validateEsiid(esiid: string) {
    return this.http.get(this.validate_esiid_url + esiid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addServiceAccount(request: Object) {
    return this.http.post(this.enrollServiceAccountUrl, request)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getProductsForEsiid(esiid: string) {
    return this.http.get(this.getProductsForEsiidUrl + esiid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  syncAccount(request: Object) {
    return this.http.post(this.syncAccountUrl, request)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  sendText(request: Object) {
    return this.http.post(this.sendMobileUrl, request)
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  sendEmail(request: Object) {
    return this.http.post(this.sendEmailUrl, request)
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getConfigConst() {
    return this.http.get(this.config_const_url)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  enrollToRewardProgram(person: any, reward_value: string) {
    let enrollObj = {
      "method": "add",
      "source": "online sale",
      "reward_value": reward_value,
      "email_address": person.email,
      "first_name": person.firstName,
      "last_name": person.lastName,
      "phone_number": person.mobilePhoneNumber,
      "zipcode": person.zip_code,
      "customer_id": person.accountNumber,
      "key": GlobalVariable.rewardsApiKey
    };

    return this.rewardAPICall(enrollObj);
  }

  rewardAPICall(request: any) {
    return this.http
      .post(this.reward_api, request)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  getUserConfig(key: string) {
    return this.http.get(this.user_config_url + key + '/')
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getDateDifferenceInDays(date1: Date, date2: Date) {
    if (date1 != undefined && date2 != undefined) {
      let strDate1: string = this.datePipe.transform(date1, "yyyy-MM-dd");
      let strDate2: string = this.datePipe.transform(date2, "yyyy-MM-dd");
      date1 = new Date(strDate1);
      date2 = new Date(strDate2);
      let diff: number = Math.floor((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));

      return diff;
    }
    return -1;
  }

	esiSearch(request: Object) {
		return this.http.post(this.esi_search_url, request)
			.toPromise()
			.then(response => response.json())
			.catch(this.handleError);
	}

	removeErcotSwitchHold(request: Object) {
		return this.http.post(this.remove_ercot_switch_hold_url, request)
			.toPromise()
			.then(response => response.json())
			.catch(this.handleError);
	}

  flagSearch(request: Object) {
    return this.http.post(this.flag_search_url, request)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  removeEsiIdHold(request: Object) {
    return this.http.post(this.remove_esiid_hold_url, request)
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  addEsiIdHold(request: Object) {
    return this.http.post(this.add_esiid_hold_url, request)
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  requestDppOverrideData(request: Object) {
    return this.http.post(this.dpp_override_data_url, request)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  submitDppOverride(request: Object) {
    return this.http.post(this.submit_dpp_override_url, request)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  getIpAddress() {
    return this.http.get('https://api.ipify.org/?format=json')
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  IsTheSessionValid(screen: string, isAgent: boolean) {

    let token = isAgent ? 'agentToken' : 'token';
    let signOutScreen = isAgent ? './internal-user/sign-in' : './enroll';

    if (this.localStorageService.get(token) == null) {
      this.router.navigate([signOutScreen]);
    }
    else {
      this.setLoader(screen, true);

      this.verifyToken({ 'token': this.localStorageService.get(token), 'isAgent': isAgent })
        .then((res) => {

          this.setLoader(screen, false);

          if (res.status === 'success' && res.isTerminated === false) {
            this.setHeaderUserLoggedIn(screen, true, res.results[0]['personal'][0]);
          }
          else {
            this.localStorageService.remove(token);
            this.router.navigate([signOutScreen]);
          }
        });
    }
  }
  getHolidayList(tdsp: any){
	return this.http
	  .post(this.holiday_list, tdsp)
	  .toPromise()
	  .then(res => res.json())
	  .catch(this.handleError);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.service.ts